// @flow

export const OL_MAP: string = 'olMap';
export const GET_BOX_EXTENT: string = 'get_box_extent';
export const BOX_EXTENT: string = 'box_extent';
export const LONGITUDE: string = 'longitude';
export const LATITUDE: string = 'latitude';
export const MARKER_ADDED: string = 'markerAdded';
export const ALTITUDE: string = 'altitude';
export const DATE_TIME: string = 'dateTime';
export const CENTER: string = 'center';
export const ROTATION: string = 'rotation';

export const MAP_INITIALIZED: string = 'map_initialized';

export const SET_DRONE_LOCATION: string = 'set_drone_location';
export const GET_DRONE_LOCATION: string = 'get_drone_location';
export const GET_DRONE_LOCATION_SUCCESS: string = 'get_drone_location_success';
export const GET_DRONE_LOCATION_FAIL: string = 'get_drone_location_fail';
export const GET_FLIGHT_TRACK: string = 'get_flight_track';
export const GET_FLIGHT_TRACK_SUCCESS: string = 'get_flight_track_success';
export const GET_FLIGHT_TRACK_FAIL: string = 'get_flight_track_fail';
export const GET_LAYERS_CONFIG: string = 'get_layers_config';
export const GET_LAYERS_CONFIG_SUCCESS: string = 'get_layers_config_success';
export const GET_LAYERS_CONFIG_FAIL: string = 'get_layers_config_fail';

export const START_DRAWING_FLIGHT: string = 'start_drawing_flight';
export const FINISH_DRAWING_FLIGHT: string = 'finish_drawing_flight';
export const CANCEL_DRAWING_FLIGHT: string = 'cancel_drawing_flight';
export const CENTER_MAP: string = 'center_map';
export const CHANGE_ROTATION: string = 'change_rotation';
export const SET_EXTENT: string = 'set_extent';
export const SET_OLLAYERS: string = 'set_ollayers';
export const SET_LABELS_CONFIG: string = 'set_labels_config';
export const SET_EDIT_MODE: string = 'set_edit_mode';
export const MAP_MODE: string = 'map_mode';

export type DroneLocation = {
    x: number,
    y: number,
    ascent: number,
    dateTime: string
};


// WEBPACK FOOTER //
// ./src/types/map.jsx